/**
 * Created by bergutov_rr on 16.06.17.
 */


Array.prototype.intersection = array => {
    this.filter(i => {
        return array.indexOf(i) >= 0;
    })
};


// WEBPACK FOOTER //
// ./src/js/extensions.js